import { render, staticRenderFns } from "./TaskNotification.vue?vue&type=template&id=7baf1ff2&scoped=true"
import script from "./TaskNotification.vue?vue&type=script&lang=js"
export * from "./TaskNotification.vue?vue&type=script&lang=js"
import style0 from "./TaskNotification.vue?vue&type=style&index=0&id=7baf1ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baf1ff2",
  null
  
)

export default component.exports